import { createSlug } from './urlHelpers';

// Strapi can recreate component IDs when an article is published. Keep old
// bookmarked URLs working by resolving their title within the same category.
export const findHelpArticle = (articles, { id, title }) => {
  const byId = articles.find(article => String(article.id) === String(id));
  if (byId) {
    return byId;
  }

  const byTitle = title
    ? articles.filter(article => article.title && createSlug(article.title) === title)
    : [];
  return byTitle.length === 1 ? byTitle[0] : null;
};
